<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 
		<div class="back-link ml-3">
			<button @click="hasHistory() ? $router.go(-1) : $router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}  })">
				<img class="pull-left" src="@/assets/back.svg">	
			</button>
		</div>
		<div class="title-div font-semibold">{{$t("login")}}</div>
		<div class="logout-link">
			<!-- <img class="" src="@/assets/logout.svg" @click="logout"> -->
		</div>
	</div>		
	<div class="login-form">
		<button @click="loginSocial('facebook')" type="submit" class="form-control btn bg-color-fb">{{$t("Facebook")}}</button>
		<button @click="loginSocial('linkedin')" type="submit" class="form-control btn bg-color-ln">{{$t("Linkedin")}}</button>
		<!-- <button @click="AuthProvider('google')" type="submit" class="form-control btn bg-color-google">Google</button> -->
		<button @click="loginSocial('google')" type="submit" class="form-control btn bg-color-google">{{$t("Google")}}</button>
		<hr class="purple-hr">
		<div class="form-group">
			<input type="email" class="form-control bg-color-grblue-border" name="email" aria-describedby="emailHelp" placeholder="Email" v-model="form.email" @blur="validateEmail" >
		</div>
		<div class="form-group">
			<input type="password" class="form-control bg-color-grblue-border" name="password" placeholder="Password" v-model="form.password">
		</div>
			<div v-if="error" class="form-group col-sm-12 text-center">
				<div class=" p-4 btn-warning">{{error}}</div>
			</div>
		<button @click="loginUser" type="submit" class="form-control btn bg-color-grblue">{{$t("login")}}</button>
	</div>
	<div class="bottom-txt-login col-sm-12"> 
		<div class="mb-5 p-4"> 
			<router-link :to="{name: 'forgotPassword'}">{{$t("Forgot Password?")}}</router-link>
		</div>

		{{$t("Don't have an account yet?")}}
		<p>
		<router-link class="bottom-text-login-a " :to="{name: 'register'}">
			{{$t("Register here")}}
		</router-link>
		</p>
	</div>
</div>
</template>

<script>

export default {
	name: "Login",
	data() {
		return{
			form:{
				email: '',
				password: ''
			},
			error: '',
			locale: ''
		}
    },
	mounted() {
		this.locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en-en'
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
        async loginUser(){ 
			this.error = null;
			if (!this.form.email) {
				this.error = 'Email required.';
				return
			} else if (!this.validEmail(this.form.email)) {
				this.error = 'Valid email required.';
				return
			}

			try {
				await this.$store.dispatch('login', this.form);
				await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}  });
			} catch (error) { 
				if (error.response.data && error.response.data.message)
					this.error = error.response.data.message;
				
				if (error.response.status === 401) {
					this.error = 'Invalid Credentials'
				}
			} 
         },
		async loginSocial(social) {
			this.error = null;
			try {
				let redirectUrl = await this.$store.dispatch('loginSocial', social);

				window.location.href = redirectUrl

			} catch (error) {			
				if(error.response.data && error.response.data.message)
					this.error = error.response.data.message;
				else
					this.error = this.$t('Something went wrong. Try again later.')
			}
		},
		 validEmail: function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		}

    }
}

</script>